import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n';
import './index.css';
import * as Sentry from '@sentry/react';
import * as amplitude from '@amplitude/analytics-browser';

amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY || '');

Sentry.init({
  dsn: 'https://bf85cef27607c49d4454536d6d2365a1@o4506316337446912.ingest.us.sentry.io/4506899347472384',
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
});

i18n();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
